import React from 'react';
import ReactDOM from 'react-dom/client';

import 'tippy.js/dist/tippy.css';
import 'rsuite/dist/rsuite.min.css';
import './styles/tokens.css';
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

// MSAL imports
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from '@azure/msal-browser';
import { msalConfig } from './sso/azure/authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});

// Auditoria de acessibilidade em tempo de desenvolvimento: o axe reavalia a
// árvore a cada render e registra as violações no console do browser, sem
// precisar escrever teste. O require condicional o mantém fora do bundle de
// produção — ver a11y/README.md.
if (process.env.NODE_ENV === 'development') {
  const reportAccessibility = require('@axe-core/react');
  const ReactDOMLegacy = require('react-dom');

  reportAccessibility(React, ReactDOMLegacy, 1000);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
// Retirando o StrictMode porque renderiza duas vezes no desenvolvimento, atrapalha em vários momentos.
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
root.render(<App pca={msalInstance} />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
